import { councilAdminInvitations } from "@/lib/api"
import { useQuery } from "@tanstack/react-query"

export type UseGetInvitationByTokenParams = {
  token: string
}

const useGetInvitationByToken = (params: UseGetInvitationByTokenParams) => {
  return useQuery({
    queryKey: [useGetInvitationByToken.QUERY_KEY, params.token],
    queryFn: async () => {
      const response = await councilAdminInvitations.getInvitationByToken(params.token)
      return response.data
    },
    enabled: !!params.token,
  })
}

useGetInvitationByToken.QUERY_KEY = "invitation-by-token"

export default useGetInvitationByToken
